export default "__VITE_ASSET__e29deebb__"